module.exports = __webpack_public_path__ + "static/media/ico-delete.2d8c3510.svg";